import styled from 'styled-components';

export const StyledMapModal = styled.div`
  .map-modal-image {
    height: 90vh;
    max-width: 90vw;
    margin-bottom: -${({ theme }) => theme.frameWidth};
  }
`;
